import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private hubConnections: Map<string, signalR.HubConnection> = new Map();

  constructor() { }

  // Inicia una nueva conexión y la almacena con una clave única
  public startConnection(connectionId: string, hubUrl: string, headers?: Record<string, string>, accessToken?: string): Promise<string | null> {
    if (this.hubConnections.has(connectionId)) {
      console.log(`La conexión con ID '${connectionId}' ya existe.`);
      return Promise.reject(`La conexión con ID '${connectionId}' ya existe.`);
    }

    const connectionBuilder = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.apiUrl}/${hubUrl}`, {
        accessTokenFactory: accessToken ? () => accessToken : undefined,
        headers: headers || {},
      })
      .withAutomaticReconnect();

    const newHubConnection = connectionBuilder.build();

    // Agregar eventos
    newHubConnection.onreconnecting(error => {
      console.warn(`🔄 Reconectando...`, error?.message);
    });

    newHubConnection.onreconnected(connectionId => {
      console.log(`✅ Reconectado con ID: ${connectionId}`);
    });

    newHubConnection.onclose(error => {
      console.warn(`❌ Conexión cerrada`, error?.message);
    });

    return newHubConnection
      .start()
      .then(() => {
        console.log(`La conexión con ID '${connectionId}' ha sido iniciada.`)
        this.hubConnections.set(connectionId, newHubConnection);
        return newHubConnection.connectionId; // Puede ser string o null
      })
      .catch(err => {
        return Promise.reject('Error al iniciar la conexión');
      });
  }

  // Agrega un listener a una conexión específica
  public addListener(connectionId: string, method: string, callback: (...args: any[]) => void): void {
    const hubConnection = this.hubConnections.get(connectionId);
    if (!hubConnection) {
      console.warn(`Conexión con ID '${connectionId}' no encontrada.`);
      return;
    }

    hubConnection.on(method, callback);
  }

  // Enviar un mensaje a través de una conexión específica
  public async sendMessage(connectionId: string, method: string, ...args: any[]): Promise<void> {
    const hubConnection = this.hubConnections.get(connectionId);
    if (!hubConnection) {
      console.warn(`Conexión con ID '${connectionId}' no encontrada.`);
      return;
    }

    await hubConnection.invoke(method, ...args)
      .then(()=>{
        console.log("MEsaje enviado")
      })
      .catch(err => console.error('Error al enviar mensaje:', err));
  }

  // Cierra una conexión y la elimina del mapa
  public stopConnection(connectionId: string): void {
    const hubConnection = this.hubConnections.get(connectionId);
    if (!hubConnection) {
      console.warn(`Conexión con ID '${connectionId}' no encontrada.`);
      return;
    }

    hubConnection.stop()
      .then(() => {
        console.log(`Conexión con ID '${connectionId}' detenida.`);
        this.hubConnections.delete(connectionId);
      })
      .catch(err => console.error('Error al detener la conexión:', err));
  }
}
